import * as React from 'react';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import * as CardUtils from '../../common/utils/cardUtils';
import './WelcomeCardFooter.scss';
import { getHostCURL } from '../../common/utils/cardUtils';

export const WelcomeCardFooter = () => {
  const isAdmin = CardUtils.getUserRole() === 'ADMIN';
  const learnMoreLink = isAdmin ? getHostCURL('/b2b/account/view/proxtraprogramdetails') : getHostCURL('/c/pro_xtra');
  return (
    <Col>
      <Row className="invisible">
        <a
          className="WelcomeCardFooter__footerLink"
          href={learnMoreLink}
          rel=" noreferrer"
        >Learn More About Pro Xtra
        </a>
      </Row>
    </Col>
  );
};
